import React from 'react';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import InputName from "../../common/Input/InputName";
import InputOnlyNumber from '../../common/Input/InputOnlyNumber';
const AddUpdateModal = ({
    setModalVisible,
    modalVisible,
    formData,
    handleChange,
    handleAddMembership,
    isUpdateMode,
    setInputError,
}) => {
    return(
       <>
       <Modal
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        size={"xl"}
      >
         <Modal.Header closeButton>
          <Modal.Title>
            {isUpdateMode ? "Update Membership" : "Add Membership"}
          </Modal.Title>
        </Modal.Header>
         <Modal.Body>
         <form onSubmit={handleAddMembership}>
         <div className="row">
         <div className="col-xl-4">
                <InputName
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  label="Name"
                  setInputNameError={setInputError}
                />
              </div>
              <div className="col-xl-4">
                <InputOnlyNumber
                  name="discountPercentage"
                  value={formData.discountPercentage}
                  onChange={handleChange}
                  label="discountPercentage"
                  setInputNameError={setInputError}
                  placeholder="Discount Percentage"
                />
              </div>
         </div>    
         <div className="text-end">
              <Button variant="secondary" onClick={() => setModalVisible(false)} className="me-4 p-2">
                Cancel
              </Button>
              <Button variant="primary" type="submit" className="p-2">
                {isUpdateMode ? "Update" : "Add"}
              </Button>
            </div>
         </form>
        </Modal.Body>
         </Modal>
       </>
    )
}
export default AddUpdateModal;